var map = {
	"./admin-white.svg": "0d97",
	"./admin.svg": "3479",
	"./alert-white.svg": "c7bd",
	"./arrow-down-black.svg": "16b4",
	"./arrow-down-gray.svg": "9c6e",
	"./arrow-down-white.svg": "d783",
	"./arrow-left-white.svg": "507d",
	"./arrow-right-white.svg": "8640",
	"./arrow-up-white.svg": "fb16",
	"./banner-long.jpg": "8e8e",
	"./banner.jpg": "301c",
	"./cross-black.svg": "3b16",
	"./cross-white.svg": "86d0",
	"./doc.svg": "d5c0",
	"./docx-white.svg": "a8ca",
	"./docx.svg": "7ecd",
	"./icon-tick.png": "3c1f",
	"./john-doe.png": "d45f",
	"./kingsland-crown.svg": "326c",
	"./lock-document-white.svg": "34f4",
	"./lock-document.svg": "76c6",
	"./lock.svg": "d3cc",
	"./logo-box.jpg": "0ac0",
	"./logo.jpg": "17be",
	"./logo.png": "9d64",
	"./logo@2x.png": "ffba",
	"./pdf-white.svg": "e29e",
	"./pdf.svg": "5fe9",
	"./refresh.svg": "f3f4",
	"./star-white.svg": "44e2",
	"./tick-circle-white.svg": "b72b",
	"./tick-white.svg": "2da4",
	"./unlock-document.svg": "468c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";